"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useHtmlId", {
    enumerable: true,
    get: function() {
        return useHtmlId;
    }
});
const _react = require("react");
let last = 0;
const useHtmlId = (id)=>(0, _react.useMemo)(()=>id !== null && id !== void 0 ? id : "el-".concat(++last), [
        id
    ]);

//# sourceMappingURL=useHtmlId.js.map